import React from 'react';
import { ReactComponent as HubSpotLogo } from '../../../assets/connectors/hubspot.svg';
import { ReactComponent as ElevenLabsLogo } from '../../../assets/connectors/elevenlabs.svg';

/** HubSpot, where new leads come from. */
export function HubSpotMark({ size = 22 }: { size?: number }) {
  return <HubSpotLogo width={size} height={size} />;
}

/** ElevenLabs, whose voice the AI caller speaks with. */
export function ElevenLabsMark({ size = 22 }: { size?: number }) {
  return <ElevenLabsLogo width={size} height={size} />;
}
